import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const scrollTo = (target, immediate) => {
  const l = window.__lenis;
  if (l) l.scrollTo(target, { immediate, offset: typeof target === "number" ? 0 : -80 });
  else if (typeof target === "number") window.scrollTo({ top: target, behavior: immediate ? "auto" : "smooth" });
  else target.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const ScrollManager = () => {
  const { pathname, hash, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const lower = pathname.toLowerCase().replace(/\/+$/, "") || "/";
    if (lower !== pathname) {
      navigate(`${lower}${search}${hash}`, { replace: true });
      return;
    }
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) scrollTo(el, false);
      }, 120);
      return () => clearTimeout(t);
    }
    scrollTo(0, true);
  }, [pathname, hash, search, navigate]);

  return null;
};
